import React, { FC } from 'react';
import DataTableCell from '@salesforce/design-system-react/components/data-table/cell';
import Button from '@salesforce/design-system-react/components/button';
import { BrowserRouter as Router, RouteComponentProps, withRouter } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { OPS_ACTION_TYPE, USAGE_TYPE } from '../../../../util/constants';
import { getUserInfo } from '../../../../store/ducks/userInfo';
import AgencyTransaction from '../../../Shared/AgencyTransaction';

interface EventId {
  caseExternalId: string;
  eventId: string;
  type: string;
  assignedUserId?: string;
  assignedUserName?: string;
  diplayOrderType?: string;
  visualIndicator?: string;
  orderId?: string;
  isAgencyRecord: boolean;
}

// interface for props that the data table cell is getting default from data table.
export interface Props extends RouteComponentProps {
  children?: FC;
  item?: EventId;
  action?: string;
}

const InventoryRequestIdCell: FC<Props> = ({
  item = {
    caseExternalId: null,
    eventId: null,
    type: '',
    assignedUserId: null,
    assignedUserName: null,
    diplayOrderType: '',
    visualIndicator: '',
    orderId: null,
    isAgencyRecord: false,
  },
  history,
  action,
}) => {
  const {
    eventId,
    caseExternalId,
    assignedUserId,
    visualIndicator,
    orderId,
    diplayOrderType,
    isAgencyRecord,
  } = item;
  const userInfo = useSelector(getUserInfo);
  // The Review Requests tab (action=Review) is only editable when the current Ops
  // user is the one the request is assigned to; otherwise it opens read-only, same
  // as the Assign Requests tab (action=Assign).
  const currentOps =
    action === OPS_ACTION_TYPE.REVIEW && assignedUserId === userInfo?.id
      ? OPS_ACTION_TYPE.REVIEW
      : OPS_ACTION_TYPE.ASSIGN;

  const goToInventoryDetails = (): void => {
    if (
      item.type === 'Pickup Return' ||
      item.type === 'Inventory Return' ||
      item.type === 'Standard Return'
    ) {
      history.push('/inventoryReturnApproval', {
        externalId: caseExternalId,
        opsAction: currentOps,
      });
    }

    if (
      item.diplayOrderType === 'Pickup Return' ||
      item.diplayOrderType === 'Inventory Return' ||
      item.diplayOrderType === 'Standard Return'
    ) {
      history.push('/inventoryReturnDetails', {
        externalId: caseExternalId,
        orderType: diplayOrderType,
        type: 'Failed',
        orderId,
        opsAction: currentOps,
      });
    }

    if (item.type === USAGE_TYPE.INVENTORY_REQUEST) {
      history.push('/InventoryQueueRequestDetails', {
        caseExternalId,
        opsAction: currentOps,
      });
    }

    if (item.type === USAGE_TYPE.EXPENSE_INVENTORY) {
      history.push('/inventoryExpenseDetails', {
        externalId: caseExternalId,
        opsAction: currentOps,
      });
    }

    if (item.diplayOrderType === USAGE_TYPE.INVENTORY_REQUEST) {
      history.push('/inventoryRequestDetails', {
        externalId: orderId,
        type: 'Failed',
        opsAction: currentOps,
      });
    }

    if (
      item.diplayOrderType === 'Transfer' ||
      item.diplayOrderType === 'Rep to Rep' ||
      item.diplayOrderType === 'Rep to Customer' ||
      item.diplayOrderType === 'Customer to Rep'
    ) {
      history.push('/inventoryTransferDetails', {
        externalId: caseExternalId,
        transferType: 'Failed',
        visualIndicator,
        status: visualIndicator,
        opsAction: currentOps,
      });
    }
  };
  return (
    <Router>
      <DataTableCell title={eventId || 'TBD'}>
        <AgencyTransaction isAgencyRecord={isAgencyRecord} />
        <Button label={eventId || 'TBD'} variant="base" onClick={goToInventoryDetails} />
      </DataTableCell>
    </Router>
  );
};

export default withRouter(InventoryRequestIdCell);
